<template>
  <div>
    <div v-if="loading" class="userlist-loading">
      <ion-spinner></ion-spinner>
      <span>Loading users...</span>
    </div>
    <div v-else>
      <div v-if="users.length > 0">
        <div v-for="user in users" :key="user.id" class="user-table-row">
          <div class="user-col username">
            <span class="user-name">{{ user.username || 'User' }}</span>
          </div>
          <div class="user-col email">
            <span class="user-email">{{ user.email || 'Email unavailable' }}</span>
          </div>
          <div class="user-col roles">
            <ion-chip v-if="user.is_admin" color="primary" class="role-chip">Admin</ion-chip>
            <ion-chip v-if="user.is_super_admin" color="tertiary" class="role-chip">Super Admin</ion-chip>
            <ion-chip v-if="user.is_owner" color="success" class="role-chip">Owner</ion-chip>
            <ion-chip v-if="!user.is_admin && !user.is_super_admin && !user.is_owner" color="medium" class="role-chip">User</ion-chip>
          </div>
          <div class="user-col actions">
            <ion-button fill="clear" size="small" @click="$emit('edit-user', user)">
              <ion-icon :icon="createOutline"></ion-icon>
            </ion-button>
            <ion-button fill="clear" size="small" color="danger" @click="$emit('delete-user', user)">
              <ion-icon :icon="trashOutline"></ion-icon>
            </ion-button>
            <ion-button fill="clear" size="small" color="primary" @click="$emit('reset-password', user)">
              <ion-icon :icon="keyOutline"></ion-icon>
            </ion-button>
          </div>
        </div>
      </div>
      <div v-else class="userlist-empty">
        <span>No Users Found</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';
import { IonButton, IonIcon, IonChip, IonSpinner } from '@ionic/vue';
import { createOutline, trashOutline, keyOutline } from 'ionicons/icons';

defineProps({
  users: {
    type: Array,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
});

defineEmits(['edit-user', 'delete-user', 'reset-password']);
</script>

<style scoped>
.user-table-row {
  display: flex;
  align-items: center;
  padding: 18px 32px;
  border-bottom: 1px solid #e5e5e5;
  background: #fff;
  font-size: 1rem;
  transition: background 0.2s;
}
.user-table-row:last-child {
  border-bottom: none;
}
.user-col {
  flex: 1;
  display: flex;
  align-items: center;
}
.user-col.username { flex: 2; }
.user-col.email { flex: 2; }
.user-col.roles { flex: 1.5; gap: 6px; }
.user-col.actions { flex: 1; justify-content: flex-end; gap: 4px; }
.user-name {
  font-weight: 500;
  color: #222;
}
.user-email {
  color: #666;
  font-size: 0.98em;
}
.role-chip {
  margin-right: 6px;
  font-size: 0.95em;
  font-weight: 500;
  --padding-start: 10px;
  --padding-end: 10px;
  --border-radius: 8px;
}
.userlist-loading, .userlist-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #888;
  font-size: 1.1em;
  gap: 12px;
}
</style> 